import { withWebResponsiveDesign } from 'src/hoc/withWebResponsiveDesign';
import { HeaderDesktopV4 } from './HeaderDesktopV4';
import { THeaderProps } from '../header/Header.types';
import { HeaderMobileV3 } from '../header-v3/HeaderMobileV3';

export const HeaderV4 = withWebResponsiveDesign<THeaderProps>(HeaderMobileV3, HeaderMobileV3, HeaderDesktopV4);
